import pre from './pre';
import post from './post';
import cart from './cart.vue';
import config from './config.vue';
import addon from './addon.vue';
import success from './success.vue';

export default {
    pre,
    components: {
        config,
        cart,
        addon,
        success
    },
    post,
}
